import { render, staticRenderFns } from "./PasswordResetDialog.vue?vue&type=template&id=22878e90&lang=pug&"
import script from "./PasswordResetDialog.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports